{
  "appointment": {
    "CONFIRMATION_NUMBER": "确认号",
    "APPOINTMENT_ID": "预约 ID",
    "APPOINTMENT_DATE": "预约日期",
    "APPOINTMENT_TIME": "预约时间",
    "APPOINTMENT_TIMEZONE": "时区",
    "APPOINTMENT_TYPE": "预约类型",
    "SCHEDULED_DURATION": "预约时长（分钟）",
    "STATUS": "状态",
    "ARRIVAL_DATE": "到达日期",
    "ARRIVAL_TIME": "到达时间",
    "DEPARTURE_DATE": "离开日期",
    "DEPARTURE_TIME": "离开时间",
    "DWELL_TIME": "停留时间（分钟）",
    "ON_TIME": "准时情况（分钟）",
    "IN_PROGRESS_DATE": "开始处理日期",
    "IN_PROGRESS_TIME": "开始处理时间",
    "WAIT_TIME": "等待时间（分钟）",
    "PROCESSING_TIME": "处理时间（分钟）",
    "WAREHOUSE": "仓库",
    "DOCK": "站台",
    "LOAD_TYPE": "货物类型",
    "LOAD_TYPE_DIRECTION": "方向",
    "RESCHEDULE_COUNT": "改期次数",
    "CREATED_BY": "创建者",
    "CREATOR_TYPE": "创建者类型",
    "CREATION_DATE": "创建日期",
    "LAST_UPDATED_BY": "最后更新者",
    "LAST_UPDATE_DATE": "最后更新日期",
    "LAST_UPDATE_TIME": "最后更新时间",
    "CARRIER_COMPANY": "承运公司",
    "CONTACT_NAME": "联系人姓名",
    "CONTACT_EMAIL": "联系人电子邮件",
    "CONTACT_PHONE": "联系人电话",
    "NOTES": "备注",
    "TAGS": "标签",
    "CUSTOM_FIELDS": "自定义字段",
    "EXTERNAL_VALIDATION_STATUS": "外部验证状态",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "外部验证错误信息",
    "CheckOut": "签出",
    "CheckInAdditionalAssetDetails": "签到附加资产详情",
    "InboundClaim": "入库索赔",
    "OutboundClaim": "出库索赔",
    "BookLoadType": "预约货物类型",
    "AssetContainerDetails": "资产集装箱详情",
    "AppointmentCompleted": "预约已完成"
  },
  "assetVisit": {
    "id": "到访 ID",
    "appointmentId": "预约 ID",
    "checkInDate": "签到日期/时间",
    "checkOutDate": "签出日期/时间",
    "carrier": "承运商",
    "warehouseName": "仓库",
    "currentStatus": "状态",
    "licensePlate": "车牌号",
    "visitType": "到访类型",
    "dotNumber": "DOT 编号",
    "phone": "电话",
    "isPlanned": "已计划",
    "driverNotes": "司机备注",
    "checkInAcknowledged": "签到已确认",
    "firstName": "身份验证名字",
    "lastName": "身份验证姓氏",
    "birthdate": "身份验证出生日期",
    "idValidationEmail": "身份验证电子邮件",
    "idValidationPhone": "身份验证电话"
  }
}
